import { cn } from "@/lib/utils";

// Figma "CTA Banner" (52:992), 1200 wide on 에이전트 상세 (203:5660).
export interface NvCtaBannerProps {
  title: string;
  description?: string;
  // Usually NvButton primary + secondary (md)
  actions?: React.ReactNode;
  className?: string;
}

function NvCtaBanner({ title, description, actions, className }: NvCtaBannerProps) {
  return (
    <section className={cn("flex flex-col items-center gap-3 rounded-nv-card bg-nv-surface-slate px-10 py-14 text-center", className)}>
      <h2 className="text-[24px] font-medium leading-[34px] tracking-[-0.02em] text-nv-text-inverse">{title}</h2>
      {description && <p className="text-nv-body-md text-nv-text-inverse-muted">{description}</p>}
      {actions && <div className="flex items-start gap-3">{actions}</div>}
    </section>
  );
}

export { NvCtaBanner };
